// extracted by mini-css-extract-plugin
export default {"buttonContainer":"VerifyCode_buttonContainer__a8NsH","resendDisabled":"VerifyCode_resendDisabled__yzylD","skeletonLoadingAnimation":"VerifyCode_skeletonLoadingAnimation__gNbKq"};